export function parseDateTimeMillis(value) {
  if (typeof value === 'number' && value > 1e11) {
    return value;
  }
  const text = String(value || '');
  const matched = text.match(/(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/);
  if (!matched) {
    return 0;
  }
  return new Date(
    Number(matched[1]),
    Number(matched[2]) - 1,
    Number(matched[3]),
    Number(matched[4]),
    Number(matched[5]),
    Number(matched[6]),
  ).getTime();
}

export function formatPredecessorDelta(deltaMs) {
  const sec = Math.max(1, Math.round(Number(deltaMs || 0) / 1000));
  if (sec < 60) {
    return `${sec} 秒`;
  }
  const min = Math.floor(sec / 60);
  const rem = sec % 60;
  if (min < 60) {
    return rem ? `${min} 分 ${rem} 秒` : `${min} 分`;
  }
  const hour = Math.floor(min / 60);
  const minRem = min % 60;
  return minRem ? `${hour} 小时 ${minRem} 分` : `${hour} 小时`;
}

function emptySelection() {
  return {
    total: 0,
    errorCount: 0,
    anrCount: 0,
    nearestDeltaMs: 0,
    items: [],
  };
}

export function selectSameLaunchPredecessors(records, currentCrashId) {
  const list = records || [];
  const current = list.find(item => item && item.crashId === currentCrashId);
  if (!current || !current.launchTimeSeconds || !current.uploadTimeMillis) {
    return emptySelection();
  }
  const predecessors = list.filter(item => item
    && item.crashId !== currentCrashId
    && item.launchTimeSeconds > 0
    && item.launchTimeSeconds === current.launchTimeSeconds
    && item.uploadTimeMillis > 0
    && item.uploadTimeMillis < current.uploadTimeMillis);
  predecessors.sort((a, b) => b.uploadTimeMillis - a.uploadTimeMillis);
  const nearest = predecessors[0];
  return {
    total: predecessors.length,
    errorCount: predecessors.filter(item => item.csType === 'ERROR').length,
    anrCount: predecessors.filter(item => item.csType === 'ANR').length,
    nearestDeltaMs: nearest ? current.uploadTimeMillis - nearest.uploadTimeMillis : 0,
    items: predecessors.slice(0, 3).map(item => ({
      ...item,
      deltaMs: current.uploadTimeMillis - item.uploadTimeMillis,
    })),
  };
}
